import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';
import { UserData } from '../../model/Users';
import { convertDateToJapaneseString } from '../../utility/ConvertUtily';
import { Company } from '../../model/Companies';

export type LoginInfoPDFProps = {
  userInfo: UserData;
  company: Company | undefined;
  qrCodeData: String;
}

export const LoginInfoPDF = ({
  userInfo,
  company,
  qrCodeData
}: LoginInfoPDFProps) => {

  Font.register({
		family: "BIZUDPGothic",
		fonts: [
			{
				src: "/fonts/BIZUDPGothic-Regular.ttf",
			},
			{
				src: "/fonts/BIZUDPGothic-Bold.ttf",
				fontWeight: "bold",
			},
		],
	});

	const styles = StyleSheet.create({
		page: {
      display: 'flex',
			flexDirection: 'column',
			backgroundColor: '#FFFFFF',
			fontFamily: "BIZUDPGothic",
			fontWeight: "bold",
      justifyContent: 'center',
      alignItems: 'center',
		},
    contentContainer: {
      width: '80%',
      alignItems: 'center',
    },
		header: {
			fontSize: 35,
			marginBottom: 40,
      textAlign: 'center',
		},
    textContainer: {
      width: '80%',
      margin: '0 auto',
      textAlign: 'left',
      alignItems: 'flex-start',
    },
    content: {
			fontSize: 23,
      marginLeft: 30,
      marginBottom: 10,
		},
    textOne: {
			fontSize: 18,
      marginBottom: 10,
      marginLeft: 30,
		},
    textTwo: {
			fontSize: 18,
      marginBottom: 10,
      marginLeft: 23,
		},
    textMarginBottom30: {
			fontSize: 18,
      marginBottom: 30,
      marginLeft: 23,
		},
    line: {
      borderTop: '1px solid black',
      width: '100%',
      marginTop: 30,
      marginBottom: 30,
    },
    qrCode: {
      width: 90,
      height: 90,
      margin: 0,
      marginTop: 4,
    },
	});

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.contentContainer}>
					<Text style={styles.header}>アプリ　ログイン情報</Text>
          <View style={styles.textContainer}>
          <Text style={styles.content}>
            <Text style={{ fontSize: 23 }}>{`氏名　　　 ： `}</Text>
            <Text style={{ fontSize: userInfo.lastName && userInfo.lastName.length > 8 ? 16 : 23 }}>
              {userInfo.lastName}
            </Text>
          </Text>
          <Text style={styles.content}>
            <Text style={{ fontSize: 23 }}>{`　　　　　　 ： `}</Text>
            <Text style={{ fontSize: userInfo.lastNameKana && userInfo.lastNameKana.length > 8 ? 16 : 23 }}>
              {userInfo.lastNameKana}
            </Text>
          </Text>
          <Text style={styles.content}>{`生年月日 ： ${userInfo.birthDate && !Number.isNaN(userInfo.birthDate.getTime()) ? convertDateToJapaneseString(userInfo.birthDate) : ''}`}</Text>
          <Text style={styles.content}>{`性別　　　 ： ${userInfo.sex === undefined ? '' : userInfo.sex === 0 ? '男性' : userInfo.sex === 1 ?'女性': 'その他'}`}</Text>
					</View>
          <View style={styles.line} />
          <View style={styles.textContainer}>
						<Text style={styles.textOne}>① 二次元コードでのアプリログイン方法</Text>
						<Text style={styles.textOne}>こちらの二次元コードを読込してください</Text>
					</View>
          <Image src={`${qrCodeData}`} style={styles.qrCode}></Image>
          <View style={styles.line} />
          <View style={styles.textContainer}>
						<Text style={styles.textTwo}>② 番号入力でのアプリログイン方法</Text>
						<Text style={styles.textMarginBottom30}>下記の3つの11桁の数字を入力してください</Text>
            <Text style={styles.content}>{`団体番号　  ： ${company?.displayId.replace(/(\d{4})(?=\d)/g,'$1 ')}`}</Text>
						<Text style={styles.content}>{`利用者番号 ： ${company ? userInfo.id.substring(userInfo.id.indexOf(company.displayId) + company.displayId.length).replace(/(\d{4})(?=\d)/g,'$1 ') : ''}`}</Text>
						<Text style={styles.content}>{`パスワード  ： ${userInfo.decryptedPasscode?.replace(/(\d{4})(?=\d)/g,'$1 ')}`}</Text>
					</View>
        </View>
      </Page>
    </Document>
  )
}

